"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const pino_1 = require("pino");
// Create a Pino logger instance
exports.logger = (0, pino_1.default)({
    level: process.env.NODE_ENV === 'production' ? 'warn' : 'info',
    // https://getpino.io/#/docs/browser
    browser: { disabled: true },
});
//# sourceMappingURL=application-logger.js.map